import * as React from "react"
import { SearchableSelect } from "./searchable-select"

// Complete list of all countries (ISO 3166-1)
export const ALL_COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda",
  "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain",
  "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia",
  "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso",
  "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Central African Republic",
  "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia",
  "Cuba", "Cyprus", "Czech Republic", "Democratic Republic of Congo", "Denmark", "Djibouti",
  "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador",
  "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland",
  "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada",
  "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong",
  "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy",
  "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo",
  "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya",
  "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Madagascar", "Malawi", "Malaysia",
  "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico",
  "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique",
  "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua",
  "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan",
  "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines",
  "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis",
  "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino",
  "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles",
  "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia",
  "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname",
  "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo",
  "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda",
  "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay",
  "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia",
  "Zimbabwe"
];

// Countries formatted as options for SearchableSelect
export const COUNTRY_OPTIONS = ALL_COUNTRIES.map(country => ({
  value: country,
  label: country
}));

// Common EU/export countries at the top for faster selection
const PRIORITY_COUNTRIES = [
  "Ireland", "United Kingdom", "Germany", "France", "Netherlands", "Belgium",
  "Italy", "Spain", "Austria", "Switzerland", "Denmark", "Sweden", "United States"
];

export const SORTED_COUNTRY_OPTIONS = [
  ...PRIORITY_COUNTRIES.map(c => ({ value: c, label: `★ ${c}` })),
  { value: "---", label: "─────────────────", disabled: true },
  ...ALL_COUNTRIES.filter(c => !PRIORITY_COUNTRIES.includes(c)).map(c => ({
    value: c,
    label: c
  }))
];

/**
 * CountrySelect - A searchable country dropdown
 * 
 * Usage:
 * <CountrySelect
 *   value={selectedCountry}
 *   onValueChange={setSelectedCountry}
 *   placeholder="Select country..."
 * />
 */
export function CountrySelect({
  value,
  onValueChange,
  placeholder = "Search and select country...",
  disabled = false,
  className,
  "data-testid": dataTestId,
}) {
  return (
    <SearchableSelect
      options={COUNTRY_OPTIONS}
      value={value}
      onValueChange={onValueChange}
      placeholder={placeholder}
      searchPlaceholder="Type to search countries..."
      emptyMessage="No country found."
      disabled={disabled}
      className={className}
      data-testid={dataTestId}
    />
  )
}

export default CountrySelect
